import React, { useContext, useEffect, useState, lazy, Suspense } from 'react'
import PropTypes from 'prop-types'
import { useLocation } from '@reach/router'
import { AuthContext } from '../../context/authProvider'
import storageService from '../../services/storageService'

import { Carousel } from '../../atomic-components/organisms/carousel'
import { Layout } from '../../atomic-components/organisms/layout'
import { Seo } from '../../atomic-components/organisms/seo'
import { ContentWrapper } from '../../atomic-components/atoms/contentWrapper'
import { useBannersApiData } from '../../hooks/graphqlStaticQuery/useBannersApiData'
const KambiSportsbook = lazy(() =>
  import('../../atomic-components/organisms/KambiSportsbook').then(
    (module) => ({
      default: module.KambiSportsbook,
    })
  )
)
import { SportsCarouselWrapper } from '../../atomic-components/atoms/SportsCarouselWrapper'
import { addTrailingSlash } from '../../utils/addTrailingSlash'
import { isFbUser } from '../../helpers/urlHelper'

const KambiSportsPage = ({
  pageContext: { page: contextPage, bannerType, eventLocation, navContext },
  location: { pathname },
}) => {
  const location = useLocation()
  const [customLocation, setCustomLocation] = useState(location)
  const [banners] = useBannersApiData([
    bannerType || isFbUser() ? 'fb_sports' : 'sports',
  ])
  const { getUserWallet } = useContext(AuthContext)

  useEffect(() => {
    storageService.setValue('lobby', location.pathname)
  })

  const updateCustomLocation = () => {
    const newLocation = window.location

    // const { href } = newLocation
    // const url = new URL(addTrailingSlash(href))
    // window.history.pushState(null, '', url)

    setCustomLocation({
      ...newLocation,
      pathname: addTrailingSlash(newLocation.pathname),
      href: addTrailingSlash(newLocation.href),
    })
  }

  const onUpdateWallet = async () => {
    await getUserWallet(true)
  }

  const [hideWrapperPadding, setHideWrapperPadding] = useState(false)

  return (
    <Layout
      page={contextPage}
      customLocation={customLocation}
      eventLocation={eventLocation}
      navContext={navContext}
      childrenFullHeight
      childrenBackground="black"
    >
      <ContentWrapper hidePadding>
        <SportsCarouselWrapper hidePadding={hideWrapperPadding}>
          <Carousel
            dontShowLoading
            slides={banners}
            setHideWrapperPadding={(value) => setHideWrapperPadding(value)}
            useGatsbyImage
          />
        </SportsCarouselWrapper>
      </ContentWrapper>
      <Suspense fallback={null}>
        <KambiSportsbook
          page={contextPage}
          pathname={pathname}
          updateCustomLocation={updateCustomLocation}
          updateWallet={onUpdateWallet}
        />
      </Suspense>
    </Layout>
  )
}

export default KambiSportsPage

export const Head = ({
  pageContext: { hreflangPage, yoast_head },
  location: { pathname },
}) => {
  const yoast = { yoast_head_json: yoast_head?.json }
  return (
    <Seo
      hrefLangPage={hreflangPage}
      pathname={pathname}
      disableCanonicalSSR
      yoast={yoast}
      pageType="sports"
    />
  )
}

KambiSportsPage.defaultProps = {
  pageContext: {},
  location: {},
}

KambiSportsPage.propTypes = {
  pageContext: PropTypes.object,
  location: PropTypes.object,
}
